import {_breakpoint, _map} from './core'

const defaultBreakpoints = {
  mobile: 0, // targeting all devices
  tablet: 737, // targeting devices that are LARGER than the iPhone 6 Plus (which is 736px in landscape mode)
  desktop: 1025, // targeting devices that are LARGER than the iPad (which is 1024px in landscape mode)
}

function breakpoint(gte, lt) {
  return (strings, ...interpolations) =>
    ({theme = {}}) =>
      _breakpoint(theme.breakpoints || defaultBreakpoints, gte, lt)(strings, ...interpolations)
}

export function map(value, mapValueToCSS) {
  return ({theme = {}}) => _map(theme.breakpoints || defaultBreakpoints, value, mapValueToCSS)
}

export function createStatic(breakpoints = defaultBreakpoints) {
  return Object.keys(breakpoints).reduce(
    (accum, name) => {
      accum[name] = _breakpoint(breakpoints, name)
      return accum
    },
    {
      breakpoint: (gte, lt) => _breakpoint(breakpoints, gte, lt),
      map: (value, mapValueToCSS) => _map(breakpoints, value, mapValueToCSS),
    }
  )
}

export default breakpoint
